import { observer } from "mobx-react";
import { Box } from "@mui/material";
import SymptomDiaryEntryForm from "../components/forms/symptomdiary/SymptomDiaryEntryForm";
import ContentBlock from "../components/ContentBlock";
import SymptomDayList from "../components/lists/SymptomDayList";
import dayjs, { Dayjs } from "dayjs";
import HeatMap from "../components/charts/HeatMap";
import { useStoreContext } from "..";
import { useEffect, useState } from "react";
import React from "react";
import InfoText from "../components/typographies/InfoText";
import { useTranslation } from "react-i18next";
import { MeasurementSaveRequest } from "../models/Measurements";
import { FieldAlias } from "../lib/enums";

const SymptomDiary = observer(() => {
  const { t } = useTranslation();
  const [selectedDay, setSelectedDay] = useState<any | undefined>(undefined);
  const { measurementStore, fieldStore } = useStoreContext();
  useEffect(() => {
    if (!measurementStore.symptoms) {
      measurementStore.getSymptoms();
    }
  }, [measurementStore.symptoms]);

  useEffect(() => {
    if (!fieldStore.fields) {
      fieldStore.getFields();
    }
  }, [fieldStore.fields]);

  if (!measurementStore.symptomDays || !fieldStore.mappedSymptomNames) {
    return null;
  }

  const symptomsKeys = Array.from(measurementStore.symptomDays.keys());
  const symptomValues = Array.from(measurementStore.symptomDays.values());

  const getSymptomDays = () => {
    const symptoms = measurementStore.symptomDays;
    if (!symptoms) {
      return "";
    }
    return symptomsKeys.map((s, index) => {
      let name = s;
      if (name === FieldAlias.C_F_D_DIARY_NOSYMPTOM) {
        return {
          name: "Inga symtom",
          dates: symptomValues[index].map((a) => dayjs(a)),
        };
      }
      return {
        name: fieldStore.mappedSymptomNames?.get(name),
        dates: symptomValues[index].map((a) => dayjs(a)),
      };
    });
  };

  const handleSelectDay = (day: Dayjs) => {
    const formDatas = measurementStore.getSymptomsByDate(dayjs(day));

    const initialForm = {
      date: dayjs(day).format("YYYY-MM-DD"),
      symptoms: formDatas.map((a) => ({
        measurementId: a.measurementId,
        fieldAlias: a.fieldAlias,
        value: a.value,
      })),
    };

    if (initialForm) {
      setSelectedDay(initialForm);
    }
  };

  return (
    <Box className="page-container">
      <Box sx={{ marginBottom: 2 }}>
        <InfoText text={t("symptomdiary.info")} />
      </Box>
      <ContentBlock title="Registrera Symtomdagboken" icon="edit" bottomMargin>
        <SymptomDiaryEntryForm
          selectedDay={selectedDay}
          onDeSelect={() => setSelectedDay(undefined)}
        />
      </ContentBlock>
      <ContentBlock title="Symtomdagboken" icon="graph" bottomMargin>
        <HeatMap items={getSymptomDays() as any} />
      </ContentBlock>
      <ContentBlock title="Symtomdagboken" icon="graph">
        <SymptomDayList onClick={handleSelectDay} />
      </ContentBlock>
    </Box>
  );
});

export default SymptomDiary;
